import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { TimeFormatPipe } from '@nx-fe/pipes';

@Component({
  selector: 'xs-updating-time',
  template: '<span>{{formattedTime}}</span>',
})
export class UpdatingTimeComponent implements OnChanges, OnDestroy {
  /** What exactly this indicator is showing */
  @Input() time: string;
  @Input() short: boolean;
  @Input() hidespan: boolean;

  formattedTime: string;

  timeoutId: any = -1;

  constructor(private timeFormatPipe: TimeFormatPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateTime();
  }

  private updateTime = () => {
    const now = new Date();
    const curDate = new Date(this.time);
    if (isNaN(curDate.getTime())) {
      this.formattedTime = '';
      return;
    }

    const formattedTime = this.timeFormatPipe.transform(curDate.getTime(), this.short);
    this.formattedTime = this.hidespan ? formattedTime.replace(/\s*\(.*?\)\s*/g, '') : formattedTime;
    // Get difference in seconds
    // eslint-disable-next-line no-bitwise
    const signedDiff = ((now.getTime() - curDate.getTime()) / 1000) | 0;
    let diff = Math.abs(signedDiff);
    if (
      diff < 60 * 60 ||
      (now.getDate() === curDate.getDate() &&
        now.getMonth() === curDate.getMonth() &&
        now.getFullYear() === curDate.getFullYear())
    ) {
      diff = diff % 60;
      if (signedDiff > 0) {
        diff = 60 - diff;
      }
    } else if (diff > 60 * 60 * 24) {
      // More than a day difference
      diff = diff % (60 * 60 * 24);
      if (signedDiff > 0) {
        diff = 60 * 60 * 24 - diff;
      }
    }

    if (this.timeoutId > 0) {
      clearTimeout(this.timeoutId);
      this.timeoutId = -1;
    }

    this.timeoutId = setTimeout(() => {
      this.updateTime();
    }, diff * 1000 + 500);
  };

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }
}
